const login = {
  'login.loginTitle': 'Login',
  'login.username.placeholder': 'Username',
  'login.password.placeholder': 'Password',
  'login.login': 'Login',
  'login.msg.empty': 'Username or password cannot be empty',
  'login.msg.loginfail': 'Unable to Login',
  'login.img': 'https://fe-static.cassmall.com/assets/images/20241207135440/login_bg_en.jpg',
  'login.msg.accountEmpty': 'Account is empty',
};

export default login;
